import type { User } from 'firebase/auth'

export interface AuthUser {
  uid: string
  email: string | null
  displayName: string | null
  photoURL: string | null
  emailVerified: boolean
}

export interface AuthResponse {
  success: boolean
  redirectTo?: string
  error?: Error
  [key: string]: unknown
}

export interface AuthCheckResponse {
  authenticated: boolean
  redirectTo?: string
  logout?: boolean
}

export const convertFirebaseUser = (user: User): AuthUser => ({
  uid: user.uid,
  email: user.email,
  displayName: user.displayName,
  photoURL: user.photoURL,
  emailVerified: user.emailVerified,
})
